import { i18n } from "@lingui/core";

export const multiResumeBrand = {
  appName: "MultiResume",
  compactName: "MR",
  tagline: "Invite-only Complete Resume beta",
  description:
    "MultiResume helps invited beta users maintain one trusted Complete Resume, create Job Versions from Job Descriptions, and review every suggestion item by item.",
  legalName: "Xi Guanwen",
  legalAddress: "Room 201, No. 14, Branch Lane 9, Lane 38, Nanda Road, Baoshan District, Shanghai, China",
  legalAddressZh: "中国上海市宝山区南大路38弄9支弄14-201",
  supportEmail: "support@multiresu.me",
  privacyEmail: "privacy@multiresu.me",
} as const;

export const multiResumeLegalLinks = [
  { label: "价格", href: "/pricing" },
  { label: "用户协议", href: "/terms" },
  { label: "隐私政策", href: "/privacy" },
  { label: "可接受使用政策", href: "/acceptable-use-policy" },
] as const;

const multiResumeLegalLinksZhTw = [
  { label: "價格", href: "/pricing" },
  { label: "使用者協議", href: "/terms" },
  { label: "隱私政策", href: "/privacy" },
  { label: "可接受使用政策", href: "/acceptable-use-policy" },
] as const satisfies ReadonlyArray<{ label: string; href: (typeof multiResumeLegalLinks)[number]["href"] }>;

const multiResumeLegalLinksEn = [
  { label: "Pricing", href: "/pricing" },
  { label: "Terms of Service", href: "/terms" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Acceptable Use Policy", href: "/acceptable-use-policy" },
] as const satisfies ReadonlyArray<{ label: string; href: (typeof multiResumeLegalLinks)[number]["href"] }>;

export type MultiResumePublicChromeCopy = {
  pricing: string;
  support: string;
  signIn: string;
  relatedNotices: string;
};

const multiResumePublicChromeCopy = {
  pricing: "价格",
  support: "支持",
  signIn: "登录",
  relatedNotices: "相关说明",
} as const satisfies MultiResumePublicChromeCopy;

const multiResumePublicChromeCopyZhTw = {
  pricing: "價格",
  support: "支援",
  signIn: "登入",
  relatedNotices: "相關說明",
} as const satisfies MultiResumePublicChromeCopy;

const multiResumePublicChromeCopyEn = {
  pricing: "Pricing",
  support: "Support",
  signIn: "Sign in",
  relatedNotices: "Related notices",
} as const satisfies MultiResumePublicChromeCopy;

export function isMultiResumeEnglishLocale() {
  return i18n.locale.toLowerCase().startsWith("en");
}

export function isMultiResumeTraditionalChineseLocale() {
  const locale = i18n.locale.toLowerCase();
  return locale.startsWith("zh-tw") || locale.startsWith("zh-hant");
}

export function getMultiResumeLegalLinks() {
  if (isMultiResumeEnglishLocale()) return multiResumeLegalLinksEn;
  if (isMultiResumeTraditionalChineseLocale()) return multiResumeLegalLinksZhTw;

  return multiResumeLegalLinks;
}

export function getMultiResumeMoreLegalLabel() {
  if (isMultiResumeEnglishLocale()) return "More legal and trust notices";
  if (isMultiResumeTraditionalChineseLocale()) return "更多法律與信任說明";

  return "更多法律与信任说明";
}

export function getMultiResumePublicChromeCopy() {
  if (isMultiResumeEnglishLocale()) return multiResumePublicChromeCopyEn;
  if (isMultiResumeTraditionalChineseLocale()) return multiResumePublicChromeCopyZhTw;

  return multiResumePublicChromeCopy;
}
